<template>
  <div>
    <Main
      ref="tableMain"
      :loading="loading"
      :tableData="tableData"
      @openDetailDialog="openDetailDialog"
      @reload="getData"
    >
      <div class="side-frame-warning" slot="header">
        <span style="font-size: 14px; color: #606266">{{
          $l('INDEX.order_tab_group_order_package_size') || '包装尺寸'
        }}</span>
      </div>
    </Main>
    <DetailDialog
      :visible.sync="detailDialogOptions.visible"
      :title="
        $l('INDEX.dialog_title_production_order_package_size_detail') ||
          '查看产品包装尺寸'
      "
      :orderGoodsCode="detailDialogOptions.code"
    />
  </div>
</template>
<script>
import Main from './main'
import DetailDialog from '../detail/dialog.vue'
export default {
  components: { Main, DetailDialog },
  props: {
    orderCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      detailDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderCode) return
      this.loading = true
      this.$api
        .pendingOrderGoodsPackageSizeListApi({ orderCode: this.orderCode })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    openDetailDialog({ orderGoodsCode }) {
      this.detailDialogOptions = {
        visible: true,
        code: orderGoodsCode,
      }
    },
  },
}
</script>
